<template>
  <div class="ArtistMoreArt">
    <div v-if="artist.more_art.length > 0" class="ArtistMoreArt-Curations mt-12">
      <h3>More art by {{ artist.full_name }}</h3>
      <div class="ArtistMoreArt_more-listings mt-10">
        <a v-for="listing in artist.more_art" :href="listing.url" class="block">
          <img :src="listing.image_url" class="img-responsive" />
        </a>
      </div>
      <a
        @click.prevent="seePortfolio"
        :href="artist.profile_url"
        class="ProfileEnquireBtn mt-10 btn btn-outline-blue text-uppercase"
      >
        See Portfolio &gt;
      </a>
    </div>

    <div v-if="artist.curations.length > 0" class="ArtistMoreArt-Curations mt-12">
      <h3>Curator's Picks</h3>
      <div class="ArtistMoreArt-Curations-Items mt-10">
        <div v-for="curation in artist.curations">
          <a :href="curation.curation_url">
            <div class="row">
              <div class="col-xs-5">
                <img :src="curation.photo_url" />
              </div>
              <div class="col-xs-7">
                <div class="ArtistMoreArt-Curations-Items-Title">{{ curation.title }}</div>
                <div class="ArtistMoreArt-Curations-Items-Date">{{ curation.created_at | formatDateMonthYear }}</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue"

const artist = inject("artist")
const setTab = inject("setTab")

const seePortfolio = () => {
  setTab("available")
}
</script>

<style scoped>
.ArtistMoreArt .ProfileEnquireBtn {
  width: 100%;
  padding: 17px 15px 17px 15px;
  font-weight: bold;
  font-size: 12px;
  letter-spacing: 2px;
  line-height: 17px;
}

.ArtistMoreArt_more-listings {
  display: grid;
  grid-template: auto / repeat(2, 1fr);
  grid-gap: 30px;
}

.ArtistMoreArt-Curations h3 {
  @apply text-primary;
}

.ArtistMoreArt-Curations-Items {
  display: grid;
  grid-template: auto / repeat(2, 1fr);
  grid-gap: 30px;
  row-gap: 20px;
}

.ArtistMoreArt-Curations-Items-Title {
  @apply text-primary uppercase;
}

.ArtistMoreArt-Curations-Items-Date {
  color: rgb(162, 148, 148);
  margin-top: 15px;
}
</style>
